const MAX_AGE_MS = 5 * 60 * 1000;

const memoryCache = new Map();

export const readCache = (kitchenKey) => {
  const entry = memoryCache.get(kitchenKey);
  if (!entry) return null;

  if (Date.now() - entry.cachedAt > MAX_AGE_MS) {
    memoryCache.delete(kitchenKey);
    return null;
  }

  return entry;
};

export const writeCache = (kitchenKey, data) => {
  memoryCache.set(kitchenKey, { data, cachedAt: Date.now() });
};

export const clearCache = (kitchenKey) => {
  memoryCache.delete(kitchenKey);
};

export const isCacheFresh = (cacheEntry) => {
  if (!cacheEntry) return false;
  return Date.now() - cacheEntry.cachedAt < MAX_AGE_MS;
};
